import { DeferredContent } from 'actions/deferredContentAction';
import { AsyncStatus } from 'utils/asyncStatusHelper';
const defaultState = {};
export default function config(state = defaultState, action) {
    switch (action.type) {
        case DeferredContent.DEFERRED_CONTENT_REQUEST:
            return Object.assign(Object.assign({}, state), { [action.id]: { asyncStatus: AsyncStatus.LOADING } });
        case DeferredContent.DEFERRED_CONTENT_SUCCESS:
            return Object.assign(Object.assign({}, state), { [action.id]: { asyncStatus: AsyncStatus.SUCCESS, content: action.content } });
        case DeferredContent.DEFERRED_CONTENT_ERROR:
            return Object.assign(Object.assign({}, state), { [action.id]: { asyncStatus: AsyncStatus.ERROR, err: action.err } });
        default:
            return state;
    }
}
